import { investmentInitialValue } from "@/types/app/investment";
import { notificationInitialValue } from "@/types/app/notifications";
import { schedulesInitialValue } from "@/types/app/schedules";

export default {
  products: [], 
  productSent: false,
  modalProduct: false,
};
